import React from 'react';
import styles from './ApexInstitute.module.css';
 // Make sure you have a director's image in this path

const ApexInstitute = () => {
    // Data extracted from the programs image
    const programs = [
        { type: 'Bachelor of Technology (B.Tech.)', duration: '4 Years', specialization: 'Computer Science Engineering (CSE)', eligibility: '45% in PCM (10+2)', affiliation: 'AKTU, Lucknow' },
        { type: 'Bachelor of Technology (B.Tech.)', duration: '4 Years', specialization: 'Electrical Engineering (EE)', eligibility: '45% in PCM (10+2)', affiliation: 'AKTU, Lucknow' },
        { type: 'Bachelor of Technology (B.Tech.)', duration: '4 Years', specialization: 'Mechanical Engineering', eligibility: '45% in PCM (10+2)', affiliation: 'AKTU, Lucknow' },
        { type: 'B.Tech (Lateral Entry)', duration: '3 Years', specialization: 'Computer Science Engineering (CSE)', eligibility: 'Diploma in relevant field', affiliation: 'AKTU, Lucknow' },
        { type: 'B.Tech (Lateral Entry)', duration: '3 Years', specialization: 'Mechanical Engineering', eligibility: 'Diploma in relevant field', affiliation: 'AKTU, Lucknow' },
        { type: 'B.Tech (Lateral Entry)', duration: '3 Years', specialization: 'Electrical Engineering (EE)', eligibility: 'Diploma in relevant field', affiliation: 'AKTU, Lucknow' },
        { type: 'Polytechnic (Diploma Engineering)', duration: '3 Years', specialization: 'Electronics Engineering (EE)', eligibility: '45% in qualifying exam, *UPJEECUP entrance exam is compulsory', affiliation: 'Board of Technical Education Polytechnic, Lucknow' },
        { type: 'Polytechnic (Diploma Engineering)', duration: '3 Years', specialization: 'Mechanical Engineering (ME)', eligibility: '45% in qualifying exam, *UPJEECUP entrance exam is compulsory', affiliation: 'Board of Technical Education Polytechnic, Lucknow' },
        { type: 'Polytechnic (Lateral Entry)', duration: '2 Years', specialization: 'Electronics Engineering (EE)', eligibility: '45% in qualifying exam, *UPJEECUP entrance exam is compulsory', affiliation: 'Board of Technical Education Polytechnic, Lucknow' },
        { type: 'Polytechnic (Lateral Entry)', duration: '2 Years', specialization: 'Mechanical Engineering (ME)', eligibility: '45% in qualifying exam, *UPJEECUP entrance exam is compulsory', affiliation: 'Board of Technical Education Polytechnic, Lucknow' }
    ];

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h1>About Apex Institute of Technology</h1>
                <p>Founded in 2007, AGI has rapidly gained a reputation for academic rigor, innovative pedagogy, and strong industry partnerships. Recognized among the Top 50 Engineering Programs in Uttar Pradesh, our department fosters an environment where creativity, problem-solving, and technological innovation thrive.</p>
            </header>

            <section className={styles.directorMessage}>
                <div className={styles.directorImageContainer}>
                    <img src="https://res.cloudinary.com/ddkyeuhk8/image/upload/v1755451782/apex/447ab387-c66b-4797-b3b3-e80a44157b23.png" alt="Dr. Dheeraj Gunwant, Director" className={styles.directorImage} />
                </div>
                <div className={styles.directorText}>
                    <h2>Message from the Director’s Desk</h2>
                    <p className={styles.quote}>"Education should be such that it creates job creators rather than job seekers." - Swami Vivekananda</p>
                    <p>The visionary management of Apex Group of Institutions is committed to providing high-quality education. Our state-of-the-art infrastructure, competent faculty, and disciplined students continue to set a benchmark for regional educational institutes.</p>
                    <p>At Apex, our entire team works relentlessly to foster the all-round growth of our students. I am confident that Apex will mold you into a world-class professional who will contribute to the prosperity of humankind.</p>
                    <h4>Dr. Dheeraj Gunwant</h4>
                    <p>Director, AIT</p>
                </div>
            </section>

            <section className={styles.programsOffered}>
                <h2>Programs Offered</h2>
                <div className={styles.tableContainer}>
                    <table className={styles.programsTable}>
                        <thead>
                            <tr>
                                <th>Program Type</th>
                                <th>Duration</th>
                                <th>Specialization</th>
                                <th>Eligibility</th>
                                <th>Affiliation</th>
                            </tr>
                        </thead>
                        <tbody>
                            {programs.map((program, index) => (
                                <tr key={index}>
                                    <td data-label="Program Type">{program.type}</td>
                                    <td data-label="Duration">{program.duration}</td>
                                    <td data-label="Specialization">{program.specialization}</td>
                                    <td data-label="Eligibility">{program.eligibility}</td>
                                    <td data-label="Affiliation">{program.affiliation}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className={styles.uniqueFeatures}>
                <h2>Unique Features</h2>
                <ul>
                    <li><strong>Leading-Edge Curriculum:</strong> Updated with industry experts to reflect the latest advancements.</li>
                    <li><strong>Experienced Faculty:</strong> Renowned professors and industry professionals.</li>
                    <li><strong>Modern Laboratories:</strong> State-of-the-art labs supporting hands-on learning and research.</li>
                    <li><strong>Industry Partnerships:</strong> Internships, live projects, and placement support.</li>
                    <li><strong>Incubation Center:</strong> Support for student startups and innovation projects.</li>
                    <li><strong>Vibrant Campus Life:</strong> A blend of academics with co-curricular activities, clubs, and sports.</li>
                </ul>
            </section>

            <section className={styles.admissionProcess}>
                <h2>Admission Process</h2>
                <p><strong>Eligibility:</strong> 10+2 with (PCM) for B.Tech; Diploma or BSc (PCM) for lateral entry.</p>
                <p><strong>Application:</strong> Fill out the online form or contact our admissions office.</p>
                <p><strong>Selection:</strong> Based on merit and/or entrance examinations as per university guidelines.</p>
            </section>

            <footer className={styles.footer}>
                <h3>Contact Information</h3>
                <p><strong>General Inquiries:</strong> +91-8218161966, +91-9205082236</p>
                <p><strong>Email:</strong> admissions@apex.in</p>
                <p className={styles.note}>Applicants are advised to verify program details prior to application, as offerings may be subject to change.</p>
            </footer>
        </div>
    );
};

export default ApexInstitute;